import useArticleTemplate from "/@src/composable/content/useArticleTemplate";
import {ArticleTemplate} from "/@src/models/content";
import {slogans} from '/@src/state/cachedSloganState'
import {useI18n} from "vue-i18n";
import {fetchKV} from "/@src/api/configRepo";
import useApi from "/@src/composable/useApi";
import {HomeSlogan} from "/@src/models/api";

export default function useHomePreference() {
  const {t} = useI18n()
  const api = useApi()
  const getSlogan =  ():string=>{
    fetchKV<HomeSlogan[]>(api,'console-home-slogan').then(res=>{
      slogans.value = JSON.stringify(res.value)
    })
    if(slogans.value){
      const slogansArray = JSON.parse(slogans.value) as HomeSlogan[]
      console.log(slogansArray)
      if(slogansArray.length===0){
        return t('default-home-slogan')
      }else {
        const index = Math.floor(Math.random() * slogansArray.length)
        return slogansArray[index].text
      }
    }else {
      return t('default-home-slogan')
    }
  }
  return {
    getSlogan
  }
}
